import React from 'react'
import { motion } from 'framer-motion'
import data from '../assets/data.json'
import { FiAward } from 'react-icons/fi'

const Timeline = () => {
  return (
    <div id='timeline'>
      <p className="section-label">Journey</p>
      <h2 className="section-title">Experience & Education</h2>

      <div className="timelineGrid">
        <div className="timelineCol">
          <h3 className="timelineColTitle">Work</h3>
          {data.experience.map((item, i) => (
            <motion.div
              className="timelineCard"
              key={item.title}
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
            >
              <span className="timelinePeriod">{item.period}</span>
              <h4>{item.title}</h4>
              <p className="timelineCompany">{item.company}</p>
              <p className="timelineDesc">{item.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="timelineCol">
          <h3 className="timelineColTitle">Certifications</h3>
          {data.certifications.map((cert, i) => (
            <motion.div
              className="certCard"
              key={cert}
              initial={{ x: 30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <FiAward className="certIcon" />
              <span>{cert}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Timeline